
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: 'CompanyProfilePage',
}) 
export default class CompanyProfilePage extends Vue {
}
